import { ApolloError, useQuery } from '@apollo/client'
import { MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'
import { MeetingsAndRequestsByReplyerQuery, MeetingsAndRequestsByReplyerQueryVariables } from '../../../types'

export default (
  replyerId: string,
  resignedView = false,
  disputedMeetingsIncluded = false,
): {
  data: MeetingsAndRequestsByReplyerQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, loading, error } = useQuery<MeetingsAndRequestsByReplyerQuery, MeetingsAndRequestsByReplyerQueryVariables>(
    MEETINGS_AND_REQUESTS_BY_REPLYER,
    {
      variables: {
        replyerId: replyerId,
        disputedMeetingsIncluded,
      },
      fetchPolicy: 'network-only',
      skip: resignedView,
    },
  )

  return { data, loading, error }
}
